import React from "react";
import { Link } from "react-router-dom";

/** Primary CTA button — ink filled, bone text, ochre on hover. */
export function ButtonPrimary({ to, href, children, onClick, type, className = "", ...rest }) {
  const cls =
    "inline-flex items-center gap-3 bg-[var(--ink)] text-[var(--bone)] px-6 py-3 font-mono text-xs uppercase tracking-[0.18em] hover:bg-[var(--ochre)] transition-colors duration-200 " +
    className;
  if (to) return <Link to={to} className={cls} {...rest}>{children}<Arrow /></Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}<Arrow /></a>;
  return (
    <button type={type || "button"} onClick={onClick} className={cls} {...rest}>
      {children}<Arrow />
    </button>
  );
}

/** Secondary CTA — outline ink on bone. */
export function ButtonSecondary({ to, href, children, onClick, type, className = "", ...rest }) {
  const cls =
    "inline-flex items-center gap-3 bg-transparent text-[var(--ink)] border border-[var(--ink)] px-6 py-3 font-mono text-xs uppercase tracking-[0.18em] hover:bg-[var(--ink)] hover:text-[var(--bone)] transition-colors duration-200 " +
    className;
  if (to) return <Link to={to} className={cls} {...rest}>{children}<Arrow /></Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}<Arrow /></a>;
  return (
    <button type={type || "button"} onClick={onClick} className={cls} {...rest}>
      {children}<Arrow />
    </button>
  );
}

function Arrow() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
